import logoUrl from '../assets/yoy-logo.png';
import { cn } from '../lib/cn';

/**
 * yoy.live 그래픽 워드마크.
 *
 * 원본은 흰 배경 JPEG 이라 다크 표면에서 흰 사각형이 되므로,
 * 흰 배경을 알파로 제거하고 여백을 트림한 PNG 를 쓴다(192x144, 알파 포함).
 * `o` 의 안쪽 카운터도 함께 뚫려 있어 다크·라이트 양쪽에서 자연스럽다.
 *
 * ⚠️ 2줄 스택형 로고(yoy 위 / .live 아래)라 **h-5(20px) 이하에서는 읽히지 않는다.**
 * 최소 h-8(32px) 이상을 권장한다. 크기는 호출부가 className 으로 정한다.
 *
 * `className` 에 색상 유틸(text-white 등)을 줘도 의미가 없다 — 이미지라 색이 고정이다.
 * 텍스트 워드마크 시절 호출부가 넘기던 색 클래스는 제거했다.
 */
export function Wordmark({ className }: { className?: string }) {
  return <img src={logoUrl} alt="yoy.live" className={cn('w-auto', className)} />;
}
